export default __webpack_public_path__ + "static/logoApl-1ba973624e1fe15a3a1bf20f1bf25031.svg";